/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

import { lazy } from 'react';

const load = (imp) => lazy(() => imp);

const pages = {
  Dashboard: import(
    /* webpackChunkName: "pages.dashboard" */
    '../pages/Dashboard'
  ),
};

const routes = [
  {
    id: 'dashboard',
    handler: load(pages.Dashboard),
    path: '/',
    hasScope: true,
    exact: true,
  },
];

export { routes as default };
